import * as React from 'react';
import { Switch, Route } from 'react-router-dom';
import { StudentClubProgrammes } from './StudentClubProgrammes';
import { ProgrammeBooking } from './ProgrammeBooking/ProgrammeBooking';

export function StudentClubProgrammesRouting(allProps: any) {
  return (
    <Switch>
      <Route path="/clubProgrammes" exact render={props => <StudentClubProgrammes {...allProps} {...props} />} />

      <Route
        path="/clubProgrammes/:programmeId/booking"
        exact
        render={props => <ProgrammeBooking {...allProps} {...props} />}
      />
    </Switch>
  );
}
